import React from "react";
import { Link } from "react-router-dom";
import { Clock, Users, MapPin, ArrowRight } from "lucide-react";
import { ASSET } from "../lib/api";
import { useLang } from "../contexts/LangContext";

const LABELS = {
  resort: "Wine Resort",
  cantina_visit: "Visita in Cantina",
  cooking_class: "Cooking Class",
  truffle_hunting: "Truffle Hunting",
  oil_tasting: "Olive Oil Tasting",
  harvest: "Vendemmia",
};

export default function ExperienceCard({ exp }) {
  const { t, formatPrice } = useLang();
  const label = LABELS[exp.type] || "Esperienza";
  return (
    <div
      data-testid={`experience-card-${exp.id}`}
      className="group relative bg-card border border-border rounded-sm overflow-hidden hover-lift"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img src={ASSET(exp.image)} alt={exp.name} loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 to-transparent" />
        <div className="absolute top-3 left-3 chip bg-white/95 text-[hsl(var(--primary))]">{label}</div>
        <div className="absolute bottom-3 left-4 right-4 text-white">
          <div className="text-[10px] uppercase tracking-[0.3em] opacity-90 flex items-center gap-1.5"><MapPin className="h-3 w-3" />{exp.region} · {exp.winery}</div>
          <div className="editorial-heading text-xl md:text-2xl leading-tight mt-1 text-balance">{exp.name}</div>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <p className="text-sm text-muted-foreground line-clamp-2">{exp.description}</p>
        <div className="mt-3 flex flex-wrap gap-3 text-xs text-muted-foreground">
          <span className="flex items-center gap-1"><Clock className="h-3 w-3" />{exp.duration}</span>
          <span className="flex items-center gap-1"><Users className="h-3 w-3" />fino a {exp.guests_max}</span>
        </div>
        <div className="mt-4 flex items-center justify-between">
          <div>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{exp.type === "resort" ? t("ui.from_price", "Da") : t("exp.per_person", "Per persona")}</div>
            <div className="text-xl font-bold editorial-heading text-[hsl(var(--primary))]">{formatPrice(exp.price, { decimals: 0 })}</div>
          </div>
          <Link to={`/esperienze/${exp.id}`} data-testid={`exp-detail-${exp.id}`} className="inline-flex items-center gap-1 text-sm font-semibold text-[hsl(var(--primary))] hover:gap-2 transition-all">
            {t("ui.view_details", "Scopri")} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
